import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add_node",
  "use": "add_node-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"add_node\"><path d=\"M4.25 6.25h1v-1h-1zM3.375 8.5h11c.759 0 1.375-.616 1.375-1.375v-3.75c0-.759-.616-1.375-1.375-1.375h-11C2.616 2 2 2.616 2 3.375v3.75C2 7.884 2.616 8.5 3.375 8.5m.125-5h10.75V7H3.5zm1.75 10v-1h-1v1zM3.5 10.75h12.25v-.125c0-.759-.616-1.375-1.375-1.375h-11C2.616 9.25 2 9.866 2 10.625v3.75c0 .759.616 1.375 1.375 1.375H10.5v-1.5h-7zm12.25 3.5V12h-1.5v2.25H12v1.5h2.25V18h1.5v-2.25H18v-1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol